export function disableSendButton(){
  document.getElementById("button").disabled = true;
  document.getElementById("spinner").hidden = false;
  document.getElementById("form").submit();
}